import { useAppSelector } from "@/store/store-hooks";
import {
  selectAllAreaDatasets,
  selectAllIElements,
  selectRootId,
} from "@faro-lotv/project-source";
import { useMemo } from "react";
import { ProjectTree } from "../project-tree/project-tree";
import { generateProjectTree } from "../project-tree/tree-generation";

/** @returns a panel to view and interact with the project tree*/
export function ProjectPanel(): JSX.Element {
  const iElements = useAppSelector(selectAllIElements);
  const areaDatasets = useAppSelector(selectAllAreaDatasets);
  const rootId = useAppSelector(selectRootId);
  const tree = useMemo(
    () => generateProjectTree(rootId ?? "", iElements, areaDatasets, false),
    [areaDatasets, iElements, rootId],
  );

  return <ProjectTree tree={tree} />;
}
